import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m2 22 1-1h3l9-9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 21v-3l9-9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Pipette";
const Pipette = memo(themed(Icon));
export {
  Pipette
};
//# sourceMappingURL=pipette.js.map
